import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class UploadImageService {

    private url = environment.urlApi;
    
    private imagenes: any[];

    constructor(private http: HttpClient) {

        console.log( 'Servicio listo' );

    }

    getApi( query: string){

         const url = `${this.url}/${query}`;

         return this.http.get<any>(url);
    }

    deleteApi( query: string){

        const url = `${this.url}/${query}`;

        return this.http.delete(url);
   }
   postoApi( query: string, objeto: any){

    const url = `${this.url}/${query}`;

    return this.http.post(url , objeto);

    }
    putApi( query: string, objeto: any){

        const url = `${this.url}/${query}`;

        return this.http.put(url , objeto);

        }

    getpropiedades(tOp, tpro, ciu, bar, dorm, dir, cochera, patio, precDesde, precHasta, moneda){
       return this.getApi( `Propiedades/list/${tOp}/${tpro}/${ciu}/${bar}/${dorm}/${dir}/${cochera}/${patio}/${precDesde}/${precHasta}/${moneda}`).toPromise();

    }
    getpropiedadesDahsboard(){
        return this.getApi( `Propiedades/dashboard`).toPromise();
 
     }
    getpropiedad(id: number){
        return this.getApi(`Propiedades/${id}`);
    }
    deletePropiedad(id: number){
        return this.deleteApi(`Propiedades/${id}`);

    }

    postImages(id: number,propiedad: any) {
        return this.postoApi(`Imagenes/${id}/images`, propiedad );

      }

    getImagenes(id: number){
        return this.getApi(`Imagenes/${id}/images`);
    }
    putPropiedad(id: string, imagenes: any) {
    return this.putApi(`Imagenes/${id}`, imagenes );

    }
    getRentalsProperties(){
        const tOp = 'ALQUILER';
        return this.getApi( `Propiedades/list/${tOp}`) .pipe(
            map((resp: any[]) =>
            resp.map(propiedades => ( 
                {
                    id: propiedades.id, 
                    name: propiedades.domicilioPropiedad[0].calle + ' ' + propiedades.domicilioPropiedad[0].numero + ' P:'+ propiedades.domicilioPropiedad[0].piso + ' D:'+ propiedades.domicilioPropiedad[0].departamento
            })
            )
            )
        ).toPromise();
 
     }

//     const params = new HttpParams().set('id', '1');

// this.http.delete(environment.apiUrl, { params })
//   .subscribe(
//     result => console.log(result),
//     err => console.error(err)
//   );
}

